module.exports = __webpack_public_path__ + "static/media/events_09.cd9a4226.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/JPEG/events_09.jpg
// module id = 5927
// module chunks = 0